module.exports = __webpack_public_path__ + "9488d02b/img/arrow-share-icon.00a12c29.svg";